import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loyaltyData: {}, // JSON string containing loyalty data
  redeemAmount: "", // Redeem amount
};

const loyaltySlice = createSlice({
  name: "loyalty",
  initialState,
  reducers: {
    setLoyaltyData: (state, action) => {
      state.loyaltyData = action.payload;
    },
    setRedeemAmount: (state, action) => {
      state.redeemAmount = action.payload;
    },
    setGuestRefCode: (state, action) => {
      state.guestRefCode = action.payload; // Update GUESTREFCODE
    },
    clearLoyaltyData: (state) => {
      state.loyaltyData = {}; // Reset loyaltyData to an empty object
      state.redeemAmount = ""; // Reset redeemAmount to an empty string
      state.guestRefCode = null;
    },
  },
});

// Selector to extract GUESTREFCODE from loyaltyData
export const selectGuestRefCode = (state) => {
  try {
    const loyaltyData = JSON.parse(state.loyalty.loyaltyData || "{}"); // Parse JSON
    const table2 = loyaltyData.Table2 || []; // Access Table2
    return table2.length > 0 ? table2[0].GUESTREFCODE : null; // Return GUESTREFCODE or null
  } catch (error) {
    console.error("Error parsing loyaltyData:", error);
    return null; // Return null if parsing fails
  }
};

export const {
  setLoyaltyData,
  setRedeemAmount,
  setGuestRefCode,
  clearLoyaltyData,
} = loyaltySlice.actions;

export default loyaltySlice.reducer;
